import React from 'react';

const IconCheckCircle: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8836 11.9996C20.8836 16.8976 16.8986 20.8826 12.0006 20.8826C7.10155 20.8826 3.11655 16.8976 3.11655 11.9996C3.11655 7.10155 7.10155 3.11655 12.0006 3.11655C16.8986 3.11655 20.8836 7.10155 20.8836 11.9996ZM22.2836 11.9996C22.2836 6.32955 17.6706 1.71655 12.0006 1.71655C6.32955 1.71655 1.71655 6.32955 1.71655 11.9996C1.71655 17.6696 6.32955 22.2836 12.0006 22.2836C17.6706 22.2836 22.2836 17.6696 22.2836 11.9996ZM9.91655 15.4166C9.78855 15.4166 9.66055 15.3676 9.56355 15.2706L7.48055 13.1866C7.28455 12.9916 7.28455 12.6746 7.48055 12.4796C7.67555 12.2846 7.99155 12.2846 8.18755 12.4796L9.92855 14.2216L15.8256 8.71755C16.0286 8.52955 16.3436 8.54055 16.5326 8.74155C16.7206 8.94355 16.7096 9.26055 16.5086 9.44855L10.2586 15.2826C10.1616 15.3726 10.0396 15.4166 9.91655 15.4166Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCheckCircle;
